export const forgotPasswordState = {
    isLoading: false,
    statusCode:'',
    errorCode:'',
    errorMessage:'',
    brandList:[],
    requestForgotPasswordDetail:{},
    verifyStatusCode:0
}

